"use client";

export type ToastVariant = "default" | "destructive" | "success" | "info";
export type ToastPayload = { title?: string; description?: string; variant?: ToastVariant; duration?: number };

export function emitToast(payload: ToastPayload) {
  try {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent('toast:show', { detail: payload }));
  } catch { /* noop */ }
}

export function emitProblemToast(problem: { title?: string; detail?: string; status?: number }) {
  const title = problem?.title || `Request failed`;
  const description = [problem?.detail, problem?.status ? `HTTP ${problem.status}` : null].filter(Boolean).join(' · ');
  emitToast({ title, description, variant: 'destructive' });
}

